import { useState, useEffect } from 'react'
import { getKyousouApiClient , ApiErrorResponse, handleError } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideExecutionPlan } from './types'

interface UseExecutionPlanDetailProps {
  slideExecutionPlan: SlideExecutionPlan | null
  setSlideExecutionPlan: (
    slideExecutionPlan: SlideExecutionPlan | null
  ) => void
  isSlideExecutionPlanLoading: boolean
}

export const useExecutionPlanDetail = (
  businessIdeaId: string
): UseExecutionPlanDetailProps => {
  const [slideExecutionPlan, setSlideExecutionPlan] =
    useState<SlideExecutionPlan | null>(null)
  const [isSlideExecutionPlanLoading, setIsSlideExecutionPlanLoading] =
    useState(false)
  const { showSnackBar } = useSnackBar()

  useEffect(() => {
    if (!businessIdeaId) return

    const slideExecutionPlan = async () => {
      setIsSlideExecutionPlanLoading(true)
      const apiClient = getKyousouApiClient()

      try {
        const response = await apiClient.business.slideExecutionDetailList(businessIdeaId)
        setSlideExecutionPlan(response.data.executionPlan)
      } catch (e) {
        handleError(e as ApiErrorResponse, showSnackBar)
      } finally {
        setIsSlideExecutionPlanLoading(false)
      }
    }

    slideExecutionPlan()
  }, [businessIdeaId])

  return {
    slideExecutionPlan,
    setSlideExecutionPlan,
    isSlideExecutionPlanLoading,
  }
}
